
<app-system-maintenance *ngIf="showMessage" (closeModal)="onCloseModal()"></app-system-maintenance>

<div class="margin-vertical mv16">
  <mapfre-alert></mapfre-alert>
</div>
<form
  name="makePaymentForm"
  [formGroup]="makePaymentForm"
  (ngSubmit)="makePaymentForm.valid && onMakePayment()"
>
  <div class="mk-payment-block">
    <div *ngFor="let input of inputs" class="input">
      <mapfre-validation
        [input]="input"
        [form]="makePaymentForm"
      ></mapfre-validation>
    </div>
  </div>
  <div class="row text-center margin-vertical mv16 find-policy-link-sec">
    <ng-container *ngIf="showZeroBalanceModal">
      <app-zero-balance-modal [policy]="policy" (closeZeroBalanceModal)="onCloseZeroBalanceModal()" ></app-zero-balance-modal>
    </ng-container>
    
      <ng-container *ngIf="payOrCancelModal">
          
          <mapfre-modal [modalOptions]="payOrCancelModalOptions" 
          [hideModal]="hideModal" 
          (click)="hideOnClick($event)"
          (hideModalOutput)="hideModalAction()"
          >
              
            <div class="modal-body" style="font-size: inherit;">
              <ng-container *ngIf="isAcmic; else maHeader">
                <hr class="margin-bottom mb16 no-margin-top"/>                              
              </ng-container>
              <ng-template #maHeader>
                <div class="ma-modal-title">{{'MODAL_MAKE_A_PAYMENT' | translate}}</div>                                                                
              </ng-template>
                  <div class="modal-body-content">
                    <ng-container *ngIf="isAcmic; else MAStatePayOrCancel">
                        <div class="row no-margin-horizontal">
                            <app-payment-alert [policy]="policy" [guest]="true" class="max-width-full"></app-payment-alert>
    
                          <div class="col-md-6 col-12" *ngIf="currentBill?.badCheckCount === 'N'">
                              <button class="btn btn-danger custom-btn acmic-make-pay" (click)="openPayment()">
                                  CHECKING/SAVINGS</button>
                          </div>
                          <div class="col-md-6 col-12 m24">
                              <button class="btn btn-danger custom-btn acmic-make-pay"  [ngClass]="{'offset-md-6' : currentBill?.badCheckCount ==='Y' }" (click)="makeDebitOrCreditPayment()">CREDIT/DEBIT CARD</button>
                          </div>
                        </div>
                    </ng-container>                    
                    <ng-template #MAStatePayOrCancel>
                      <div class="row no-margin-horizontal">
                        <app-payment-alert [policy]="policy" [guest]="true" class="max-width-full"></app-payment-alert>
                      <section class="mk-payment-links">
                      <div class="" *ngIf="currentBill?.badCheckCount === 'N'">
                        <a class="left-side-payment dm-sans-medium font-size medium-font" (click)="openPayment()">
                          <img src="./assets/img/images/icon-compensation.svg" alt="compensation icon" width="64px" height="64px" />
                          <span class="mt-4 mb-3 brand-lite-blue">
                            {{'CHECKING_SAVINGS_ACCOUNT' | translate}}
                          </span>
                          <span class="mapfre link red-link">
                            Select 
                            <img src="./assets/img/images/icon-simple-arrow-right-red.svg" alt="right arrow icon" width="24px" height="24px" />
                          </span>
                        </a>
                      </div>
                      <div class="">
                        <a class="right-side-payment dm-sans-medium font-size medium-font" (click)="makeDebitOrCreditPayment()">
                          <img src="./assets/img/images/icon-credit-cards.svg" alt="credit card icon" width="64px" height="64px" />
                          <span class="mt-4 mb-3 brand-lite-blue">
                            {{'CREDIT_DEBIT_CARD' | translate}}
                          </span>
                          <span class="mapfre link red-link">
                            Select 
                            <img src="./assets/img/images/icon-simple-arrow-right-red.svg" alt="right arrow" width="24px" height="24px" />
                          </span>
                        </a>
                      
                      </div>
                    </section>
                    </div>
                    <div class="row">
                      <div class="col mk-pay-cancel-btn margin-top mt8">
                        <mapfre-button additionalClasses="mk-cancel-btn x-small-btn" 
                        (click)="hideModalAction()"                   
                        >
                          {{ "CANCEL" | translate }}
                        </mapfre-button>
                      </div>
                    </div>
                    </ng-template>
                  </div>
                </div>
          </mapfre-modal>
      </ng-container>
    <div class="col">
      <mapfre-modal 
        [modalOptions]="whereToFindModalOptions" 
        [hideModal]="hideModal" 
        (hideModalOutput)="hideModalAction()">
        <div class="modal-body no-padding-top locatepolicynum">
          <hr class="margin-bottom mb24" />
          <div class="margin-bottom mb8 fs-14" *ngIf="!isAcmic">
            {{ "SEARCH_YOUR_POLICY_DOCUMENTS_INVOICES" | translate }}
          </div>
          <div class="margin-bottom mb24" *ngIf="!isAcmic">
            <img src="./assets/img/images/Document_ref.png" alt="document ref " />
          </div>
          <div class="margin-bottom mb24" *ngIf="isAcmic">
              {{ "SEARCH_YOUR_POLICY_DOCUMENTS_INVOICES" | translate }}
            <img src="./assets/img/images/Document_ref.svg" alt="document ref"/>
          </div>
          <mapfre-button
              additionalClasses="basic primary large-btn no-margin"
              (click)="hideModalAction()"
            >
              {{"CLOSE" | translate }}
            </mapfre-button>
        </div>
      </mapfre-modal>
    </div>
  </div>
  <div class="row margin-top mt16">
    <div class="col text-center">
      <mapfre-button
        [ngClass]="{ custom_loader: loader }"
        [additionalClasses]="'basic primary large-btn mt-1'"
        [disabledValue]="makePaymentForm.valid && enableBtn && !loader"
        [inputType]="'submit'"
        [translateValue]="'CONTINUE' | translate"
      ></mapfre-button>
    </div>
  </div>
</form>
<hr class="margin-vertical mv24"  *ngIf="isAcmic" />

<section class="mk-payment-block">
  <span class="margin-right mr8" [ngClass]="{'mt-4' : !isAcmic }" style="display:inline-block">
    <ng-container *ngIf="isAcmic; else MAStateConvenience">
      <svg-mailing-fast-svg></svg-mailing-fast-svg>
    </ng-container>
    <ng-template #MAStateConvenience>
      <img src="./assets/img/images/icon-payment-convenience.svg" alt="payment icon" width="64px" height="64px" />
    </ng-template>
  </span>
  <span class="title-copy save-time-money">{{ "Save time and money!" | translate }}</span>
</section>

<ng-container *ngIf="isAcmic; else MAStateDisclaimer">
  <div
  class=" text-center disclaimer disclaimer-large-size legal mk-payment margin-vertical mv16"
>
  {{ "For additional Billing & Payment options," | translate }}
  <br />
  <span>
    {{ "please log into " | translate }}
  </span>
  <strong>
    <a class="link-button blue-link" [routerLink]="['/login']">{{
      "My Account" | translate
    }}</a>
  </strong>
</div>

<div
  class="text-center disclaimer disclaimer-large-size legal margin-vertical mv16"
>
  {{ "No online account yet?" | translate }}
  <br />
  <strong>
    <a class="link-button blue-link" [routerLink]="['/signup']">{{
      "Create Your Account" | translate
    }}</a>
  </strong>
</div>

<div
  class="text-center disclaimer disclaimer-large-size legal margin-vertical mv16"
>
  <span>{{ "By logging in, you can pay with a checking" }}</span>
  <br />
  <span>
    {{ "account, set up autopay, go paperless," }}
  </span>
  <br />
  <span>{{ "access policy details, manage claims, and" }}</span>
  <br />
  <span>{{ "much more" }}</span>
</div>
</ng-container>
<ng-template #MAStateDisclaimer>
  <div
  class=" text-center disclaimer disclaimer-large-size legal mk-payment margin-vertical mv16"
>
  {{ "For additional billing & payment options," | translate }}
  <span>
    {{ "please log in to " | translate }}
  </span>
  <strong>
    <a class="break-line link-button mapfre link red-link underlineBQ dm-sans-medium" [routerLink]="['/login']">{{
      "My account" | translate
    }}</a>
  </strong>
</div>

<div
  class="text-center disclaimer disclaimer-large-size legal mk-payment margin-vertical mv16"
>
  {{ "No online account yet?" | translate }}
  <br />
  <strong>
      <a class="link-button mapfre link red-link underlineBQ dm-sans-medium" [routerLink]="['/select-account-type']">
        {{ "Create your account" | translate }}
      </a>
  </strong>
</div>

<div
  class="text-center disclaimer disclaimer-large-size legal mk-payment margin-vertical mv16"
>
  <span>{{ "By logging in, you can pay with a checking" }}</span>
  <span>
    {{ "account, set up autopay, go paperless," }}
  </span>
  <span>{{ "access policy details, manage claims, " }}</span>
  <span>{{ "and much more" }}</span>
</div>
</ng-template>